import { useEffect, useState } from "react";
import { PropTypes } from "prop-types";

function Icon({ data }) {
  const [style, setStyle] = useState({});

  useEffect(() => {
    let info = document.body.getBoundingClientRect();
    let margin = 50;

    let max_width = info.width - 50 - margin;
    let max_height = info.height - 50 - margin - 70 - 20;
    let min_height = margin;
    let min_width = margin;

    const offset = 125;

    let random_position = {
      top: Math.abs(
        Math.round(
          (Math.random() * (max_height - min_height + 1) + min_height) / offset
        ) * offset
      ),
      left: Math.abs(
        Math.round(
          (Math.random() * (max_width - min_width + 1) + min_width) / offset
        ) * offset
      ),
    };

    setStyle({
      top: random_position.top + "px",
      left: random_position.left + "px",
    });
  }, []);

  function open() {
    if (window.updateTaskbar)
      window.updateTaskbar(data.id.toLowerCase(), "opened");
  }

  function dragElement(elmnt) {
    // https://www.w3schools.com/howto/howto_js_draggable.asp
    var pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

    elmnt.onmousedown = dragMouseDown;

    function dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      document.onmousemove = elementDrag;
    }

    function elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      elmnt.style.top = elmnt.offsetTop - pos2 + "px";
      elmnt.style.left = elmnt.offsetLeft - pos1 + "px";
    }

    function closeDragElement(e) {
      const offset = 125;
      elmnt.style.top = Math.round(elmnt.offsetTop / offset) * offset + "px";
      elmnt.style.left = Math.round(elmnt.offsetLeft / offset) * offset + "px";
      document.onmouseup = null;
      document.onmousemove = null;
    }
  }

  useEffect(() => {
    let icon = document.getElementById("dicon-" + data.id.toLowerCase());
    dragElement(icon);
  }, []);

  let clicks = [];
  let timeout;

  function clickHandler(event) {
    event.preventDefault();
    clicks.push(new Date().getTime());
    window.clearTimeout(timeout);
    timeout = window.setTimeout(() => {
      if (
        clicks.length > 1 &&
        clicks[clicks.length - 1] - clicks[clicks.length - 2] < 250
      ) {
        open(event.target);
      }
    }, 250);
  }

  return (
    <div
      id={"dicon-" + data.id.toLowerCase()}
      style={style}
      className="icon"
      onClick={clickHandler}
    >
      <div>
        <img
          onError={(e) => (e.target.src = "./apps-icons/home.svg")}
          alt="window's desktop icon"
          src={"./apps-icons/" + data.id + ".svg"}
        />
      </div>
      <p>{data.name}</p>
    </div>
  );
}

Window.PropTypes = {
  data: PropTypes.object,
};

export default Icon;
